const en = {
  welcome_to_agami: 'Welcome to Agami Route',
  login: 'SIGN IN',
  send_email: 'SEND EMAIL',
  login_with_password: 'Login with password',
  login_with_email: 'Login with email only',
  lang: 'English',
  select_lang: 'Choose your language',
  day: 'Day',
  night: 'Night',
  confirm: 'Confirm',
  continue: 'Continue',
  cancel: 'Cancel',
  refresh: 'Reload',
  yes_continue: 'Yes, continue',
  start: 'Start',
  back: 'Back',
  wait: 'Plase wait...',
  headset: 'Please use the provided headset for a better experience',
  raise_volume: "Turn up your device's volume",
  sound: 'Can you hear the sound correctly?',
  wait_location: 'Location accuracy check',
  gps: 'The app is trying to get your location',
  gps_error: "There's a problem with this phone GPS",
  gps_quality_bad: 'Location accuracy poor',
  gps_quality_bad_details: 'You may experience issues with automatic playback',
  gps_quality_average: 'Location accuracy acceptable',
  gps_quality_good: 'Location accuracy excellent',
  cookies: "There's a tour already in progress",
  cookies_action: 'Would you like to continue or to start it again?',
  cookies_delete: 'Change experience',
  cookies_maintain: 'Continue experience',
  unlocking: 'If you need to use the app during the visit, unlock it using this code',
  // unlock: 'Unlock with an "L"',
  unlock: 'Confirm unlock?',
  unlock_subtitle: 'Unlocking the screen is for admins only',
  areyouready: 'Ready to start?',
  welcome: 'WELCOME',
  map: 'Map',
  code: 'Content',
  insert_code: "Enter the content ID and tap the 'Play' button",
  faq: [
    {
      q: 'Connection problems?',
      a: 'If you are experiencing connection problems try to...',
    },
    {
      q: 'Other FAQ',
      a: 'If you are experiencing connection problems try to...',
    },
  ],
  mobile_only: 'This App was designed for mobile devices.',
  screen_locked: 'Screen locked',
  swipe_left: 'Swipe left to unlock',
  admin_title: 'Admin controls',
  admin_close: 'Close',
  admin_test: 'Audio test',
  admin_reset_soft: 'Change experience',
  admin_reset_hard: 'App reset',
  admin_reset_hard_confirm: 'Do you want to reset the app?',
  admin_reset_hard_desc:
    "App reset will erase all the saved experiences and their content. You'll need to download them again.",
  admin_logout: 'Logout',
  admin_logout_confirm: 'Logout now?',
  admin_logout_desc: 'You must scan the QR or enter credentials to log in again.',
  search_gps: 'Waiting for GPS coverage',
  select_experience: 'Select an experience',
  no_experience: "Seems you don't have any available experience.",
  pause: 'Pause',
  stop: 'Stop',
  stop_all: 'Stop all',
  close: 'Close',
  no_description: 'No description',
  stop_video: 'Stop video playback',
  restart: 'Resume',
  beforestart: "Touch the 'Start' button when you are ready to begin the experience.",
  ispause: 'EXPERIENCE IS PAUSED',
  ispause_restart: "Click the 'Play' button to resume it.",
  play: 'Play',
  audio_ready: 'agami active! Push the button below to listen to it.',
  offline_experience: 'Offline experience',
  replay_title: 'Content is available for replay',
  replay_message: 'There is content available you already listened to. Do you want to replay it?',
  redeem_exp_title: 'Redeem experience',
  redeem_exp_result_title: 'Experience redeemed',
  redeem_exp_button: 'ACTIVATE',
  go_to_exp_button: 'START',
  check_email_login: 'Check your email to confirm login.',
  redeemed_until_days: 'You have access for the next',
  redeemed_until_date: 'You have access until',
  alreadly_redeemed: 'It seems you used this code before. You should already have this experience.',
  redeem_ok: 'The experience has been succesfully created for you.',

  gps_location_unavailable: 'Location services unavailable',
  gps_location_unavailable_desc:
    'Location services are either disabled or permissions for access has not been granted. Please follow instructions on how to check correct settings.',
  gps_location_open_phone_settings: 'Open phone settings',
  gps_location_browser_in_use: 'the browser you are using',

  gps_location_android_1: 'Go to "Location"',
  gps_location_android_2: 'Check that "Use location" is enabled',
  gps_location_android_3: 'Open "App location permissions"',
  gps_location_android_4: 'Scroll to bottom in section "Not allowed", and look if',
  gps_location_android_5: 'is in there',
  gps_location_android_6:
    'If that\'s the case, click over it and select either "Ask every time" or "Allow only while using the app"',

  gps_location_ios_1: 'Go to "Privacy & Security" > "Location Services"',
  gps_location_ios_2: 'Check that "Location Services" is on',
  gps_location_ios_2_1_chrome: 'Also check that the service is active for Chrome in the list below',
  gps_location_ios_2_1_safari: 'Also check that the service is active for Safari in the list below',
  gps_location_ios_3: 'Go back to phone settings',
  gps_location_ios_4: 'Scroll down and search for the settings of',
  gps_location_ios_5: 'Inside settings, search for "Location"',
  gps_location_ios_6: 'Set it to either "Ask" or "Allow"',

  gps_location_chrome_1: 'Open Chrome',
  gps_location_chrome_2: 'Navigate to',
  gps_location_chrome_3: 'Open site settings by clicking the sliders icon just left of the website address',
  gps_location_chrome_4: 'Select "Permissions"',
  gps_location_chrome_5: 'Check that "Location" is allowed',

  gps_location_safari_1: 'Open Safari',
  gps_location_safari_2: 'Navigate to',
  gps_location_safari_3: 'Open site settings by clicking "Aa" icon just left of the website address',
  gps_location_safari_4: 'Select "Website settings"',
  gps_location_safari_5: 'Under "Allow" section, check that "Location" is set to either "Ask" or "Allow"',
  gps_location_safari_6: 'Click "Done"',

  gps_location_browser_1: 'Open your preferred browser',
  gps_location_browser_2: 'Navigate to',
  gps_location_browser_3: 'Open website settings',
  gps_location_browser_4: 'Check that location access permission is set to either "Ask" or "Allow"',

  go_without_gps: 'Proceed without location',
  go_without_gps_warning: "You'll only be able to play content by manually entering codes.",

  read_instructions: 'Read the instructions',

  go_home: 'Home page',

  multiple_agami_active: 'Multiple agami active',

  pwa_install_cta: 'Get the best experience!',
  pwa_install_description:
    "Install Agami Route on your device — it's fast, light, and works just like a regular app.",
  install: 'Install',
  aria_pwa_install_dialog: 'Install Agami Route dialog',
  aria_dismiss_pwa_install: 'Dismiss install prompt',

  unsupported_browser_title: 'Unsupported browser',
  unsupported_browser_description:
    'Some essential features of this app do not work correctly on this browser.',
  unsupported_browser_open_with: 'For the app to work correctly, open this address with {browser}',
  copy_address: 'Copy address',
  address_copied: 'Address copied',
  address_copy_error: 'Could not copy the address',
  understood_continue: 'Got it, continue anyway',
  aria_unsupported_browser_dialog: 'Unsupported browser warning',

  agami_not_found: 'No agami found with this code.',
  multiple_agami_found: 'Multiple agami found with this code.',

  resume: 'Resume',

  qr_scan: 'SCAN QR',
  qr_invalid: 'Invalid QR code',
  qr_frame_instruction: 'Frame the QR code within the white borders',

  text_size: 'TEXT SIZE',
  standard: 'Standard',
  large: 'Large',
  xlarge: 'Larger',

  aria_select_experience: 'Select experience',
  aria_download_experience: 'Download experience',
  aria_download_experience_in_progress: 'Downloading experience {experience}',
  aria_cancel_download: 'Cancel download',
  aria_refresh_experience: 'Refresh experience',
  aria_next_element: 'Next element',
  aria_previous_element: 'Previous element',
  aria_open_language: 'Open language selection',
  aria_close_language: 'Close language selection',
  aria_open_font_size: 'Open text size selection',
  aria_close_font_size: 'Close text size selection',
  aria_activate_dark_theme: 'Current theme: day. Activate to switch to night theme',
  aria_activate_light_theme: 'Current theme: night. Activate to switch to day theme',
  aria_rewind_10_secs: 'Rewind 10 seconds',
  aria_fast_forward_10_secs: 'Fast forward 10 seconds',
  aria_open_audio_player: 'Open audio player',
  aria_close_audio_player: 'Close audio player',
  aria_audio_player_dialog: 'Active audio dialog',
  aria_audio_playback_progress: 'Audio playback progress',
  aria_audio_elapsed_time: 'Elapsed time {elapsed}, of total duration {total}',
  aria_login_with_email_only: 'Switch to login mode with email only',
  aria_login_with_email_password: 'Switch to login mode with email and password',
  aria_offline_mode: 'Access offline mode',
  aria_send_otp_email: 'Send email for access',
  aria_show_password: 'Show password',
  aria_hide_password: 'Hide password',
  aria_open_qr_scanner: 'Open QR scanner',
  aria_close_qr_scanner: 'Close QR scanner',
  aria_qr_panel: 'QR scanner panel',
  aria_qr_scanner_preview: 'QR scanner camera preview',
  aria_manual_playback_code_input: 'Manual playback code',
  aria_start_manual_content: 'Start manual content',
  aria_redeem_experience: 'Redeem experience',
  aria_experience_redeem_code_input: 'Experience redeem code',
  aria_loading: 'Loading',
  aria_go_to_experience: 'Go to experience',
  aria_manual_playback_code_dialog: 'Manual playback code input page',
  aria_replay_content_dialog: 'Content replay dialog',
  aria_open_video_player: 'Open video player',
  aria_close_video_player: 'Close video player',
  aria_active_video_dialog: 'Active video dialog',
  aria_collapsed_video_player: 'Collapsed video player',
  aria_collapse_video_player: 'Collapse video player',
  aria_expand_video_player: 'Expand video player',
  aria_open_controls_menu: 'Open controls menu',
  aria_close_controls_menu: 'Close controls menu',
  aria_onboarding_step_sentence: 'Onboarding step number {current} out of {total}',

  experience_redeemed_successfully: 'Experience redeemed successfully',
  something_went_wrong: 'Something went wrong',

  language: 'Language',

  manual_code_heading: 'You scanned an agami',
  manual_code_intro: 'This is Agami Route.',
  manual_code_explanation: 'To listen to it, open the code in the Agami Route app:',
  manual_code_step_1: 'Open Agami Route and choose the experience this agami belongs to',
  manual_code_step_2: 'Tap "Start"',
  manual_code_step_3: 'Open the "Content" section',
  manual_code_step_4: 'Tap "SCAN QR" and frame this code again',
  manual_code_qr_hint: 'If you cannot find the "SCAN QR" button, enter the code manually and tap "Play".',
  manual_code_label: 'Code',
  manual_code_cta_get_app: 'Get the App',
  manual_code_cta_continue: 'Continue in the app',
  manual_code_footer: 'For more info visit',

  aria_logo: 'Agami Route logo',
  aria_heading: 'Manual code scan explanation',
  aria_explanation: 'Explanation about how to use the scanned manual code',
  aria_button_get_app: 'Download the Agami Route app',
  aria_button_continue: 'Continue in the Agami Route app',

  credits: 'Credits',
  noCredits: 'There are no credits for this experience yet',

  download_experience_title: 'Download experience',
  download_experience_preparing: 'Preparing download...',
  download_experience_config: 'Downloading configuration...',
  download_experience_audio: 'Downloading audio...',
  download_experience_video: 'Downloading video...',
  download_experience_credits: 'Downloading credits...',
  download_experience_maps: 'Downloading maps...',

  download_experience_error: 'Error while downloading the experience',
  download_experience_area_too_wide: 'The map area for this experience is too large to use offline',
  download_experience_done: 'Experience downloaded and ready for offline use!',
  download_experierience_config_error:
    'Saved experience has configuration issues. Go online and download it again',
  download_experience_not_allowed: 'Offline mode is not allowed for this experience',

  get_experience_data_error: 'Error getting experience data',
  get_experience_config_error: 'Error getting experience configuration',

  session_expired_title: 'Session expired',
  session_expired_message: 'Your session expired and you have been logged out. Please log in again.',
  session_expired_action: 'Log in again',

  wrong_credentials: 'Wrong credentials',
  invalid_email: 'Invalid email',
  reset_password_instructions: 'Instructions have been sent. Check your email',
};

export default en;
